import type { InfiniteQueryKeyData, InfiniteQueryParams } from '@pba/react-query';
import type { UserDataObject } from '#models/services';
import { useInfiniteQuery } from '#react-query';
import { findUsers } from '../../services';
import { DEFAULT_PAGE_SIZE, useGetUsersParameters } from './hooks';
import { getUsersInfiniteQueryKey } from './keys';
import type { UsersQueryFilter } from './useGetUsers';

export type GetUsersInfiniteQueryParams = InfiniteQueryParams<UsersInfiniteQueryData, UsersQueryFilter>;

export type UsersInfiniteQueryData = InfiniteQueryKeyData<UserDataObject[], typeof getUsersInfiniteQueryKey>;

export const useGetUsersInfinite = ({ filter, options, pagination }: GetUsersInfiniteQueryParams) => {
  const getUsersParameters = useGetUsersParameters();
  const pageSize = pagination?.pageSize ?? DEFAULT_PAGE_SIZE;

  return useInfiniteQuery({
    async queryFn({ pageParam }) {
      const response = await findUsers({
        config: {
          params: getUsersParameters({ filter, pagination, skip: pageParam ?? 0 }),
        },
      });

      return response.data.data;
    },
    initialPageParam: 0,
    getNextPageParam(lastPage, allPages) {
      if (lastPage.length < pageSize) {
        return undefined;
      }

      return allPages.reduce((total, page) => total + page.length, 0);
    },
    queryKey: getUsersInfiniteQueryKey({ filter, pagination }),
    ...options,
  });
};
